import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import VerifyOTPApi from "./apihook/VerifyOTPApi";
import CheckUserApi from "./apihook/CheckUserApi";
import ToastMsg from "components/common/ToastMsg";
import { ImagePaths } from "utils/ImagePath";
import CustomOtpInput from "components/common/CustomeOTPInput";

const OtpVerification = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [seconds, setSeconds] = useState(60);
  const [timerRunning, setTimerRunning] = useState(false);

  const authtoken = sessionStorage.getItem("token");
  const id = state ? parseInt(state.id) : 0;
  const email = state ? state.email : "";

  // Start timer on mount
  useEffect(() => {
    let timerInterval;
    const startTimer = () => {
      setSeconds(60);
      setTimerRunning(true);
      timerInterval = setInterval(() => {
        setSeconds((prev) => {
          if (prev > 0) return prev - 1;
          clearInterval(timerInterval);
          setTimerRunning(false);
          return 0;
        });
      }, 1000);
    };
    startTimer();
    return () => clearInterval(timerInterval);
  }, []);

  // Handle OTP change
  const handleOtpChange = (value) => {
    setOtp(value);
  };

  // Verify OTP
  const onFinish = () => {
    if (otp.length !== 4) {
      ToastMsg("error", "Please enter the 4-digit OTP");
      return;
    }
    setLoading(true);
    VerifyOTPApi(
      otp,
      authtoken,
      id,
      email,
      (data) => {
        setLoading(false);
        ToastMsg("success", data.message);
        navigate("/resetpassword", {
          state: { id, user_name: data.user_name, email },
        });
      },
      (error) => {
        setLoading(false);
        ToastMsg("error", error);
      }
    );
  };

  // Resend OTP
  const handleResend = () => {
    if (timerRunning) return;
    setLoading(true);
    CheckUserApi(
      { email },
      authtoken,
      (data) => {
        setLoading(false);
        ToastMsg("success", data.message);
        setSeconds(60);
        setTimerRunning(true);
      },
      (error) => {
        setLoading(false);
        ToastMsg("error", error);
      }
    );
  };

  return (
    <div className="h-screen flex items-center justify-center relative bg-gray-50 font-sans">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-[url('https://media.istockphoto.com/id/1407540811/photo/one-time-password.jpg?s=1024x1024&w=is&k=20&c=Mb8htfVz3o_cx6T13QXl3VRYDYdF8h8yVtllaopY0Ak=')]
        bg-cover bg-center opacity-10"
      ></div>
      <div className="absolute inset-0 bg-white/40 backdrop-blur-sm"></div>

      {/* Card */}
      <div className="w-full max-w-sm relative z-10">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <img
            src={ImagePaths.loginLogo.default}
            alt="App Logo"
            className="h-10 w-auto animate-fadeIn"
          />
        </div>

        <div className="bg-white/90 backdrop-blur-md rounded-xl shadow-xl p-6 animate-fadeIn">
          {/* Header */}
          <div className="flex items-center mb-4">
            <img
              src={ImagePaths.backArrow.default}
              alt="Back"
              className="h-5 w-5 cursor-pointer mr-2"
              onClick={() => navigate("/forgotpassword", { state: { id, email } })}
            />
            <h2 className="text-lg font-semibold text-gray-800">
              Verify Your OTP
            </h2>
          </div>
          <p className="text-[13px] text-gray-500 text-center">
            A confirmation code has been sent to
          </p>
          <p className="text-[13px] text-gray-700 font-medium text-center mb-5">
            {email || "Registered Mail ID"}
          </p>

          {/* OTP Input */}
          <div className="flex justify-center mb-4">
            <CustomOtpInput numInputs={4} onChange={handleOtpChange} />
          </div>
          <p className="text-[13px] text-gray-500 text-center mb-4">
            Please enter the code for verification
          </p>

          {/* Verify Button */}
          <button
            onClick={onFinish}
            disabled={loading || otp.length !== 4}
            className={`w-full py-2 px-4 rounded-lg text-white font-semibold transition ${
              loading || otp.length !== 4
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-[#04b7b1] hover:bg-[#04b7b1]/80 focus:ring-2 focus:ring-[#04b7b1] focus:ring-offset-2"
            }`}
          >
            {loading ? "Verifying OTP..." : "Verify OTP"}
          </button>

          {/* Resend */}
          <div
            className={`text-center mt-5 text-[13px] font-medium cursor-pointer ${
              timerRunning ? "text-gray-400 cursor-not-allowed" : "text-[#04b7b1]"
            }`}
            onClick={handleResend}
          >
            Haven’t received code? Send again
          </div>

          {/* Timer */}
          <p className="text-[13px] text-gray-500 text-center mt-2">
            ⏱ 00 : {seconds < 10 ? `0${seconds}` : seconds}
          </p>
        </div>
      </div>
    </div>
  );
};

export default OtpVerification;
